import React from 'react'
import Alert from '../Components/Alert/Alert'
import Top from '../Components/Section/Top';
import YouTube  from '../Components/Youtube/Youtube';
const Home = () => {
  return (
    <>
    <Alert />
    <Top />
    <YouTube />
    </>
  )
}

export default Home